import { matchConsolidationDetailRoutePath, matchOrgDetailPath } from '@futrli/shared-services';
import { useLocation } from 'react-router-dom';

/**
 * This will return the workspaceId and organisationId from the current route, or from a provided pathname.
 * It works for both organisation and consolidation routes.
 * It does not rely on useParams from react-router-dom, as that does not work for components high up in the
 * component tree, such as our global dialogs.
 * @param pathname - Optional pathname to use. Will default to current url pathname
 */
export const useOrgRouteParams = (pathname?: string) => {
  const { pathname: currentPathname } = useLocation();
  const p = pathname || currentPathname;

  const orgMatch = matchOrgDetailPath(p, false);
  const conMatch = matchConsolidationDetailRoutePath(p, false);

  const match = orgMatch || conMatch;
  const { workspaceId = '', organisationId = '' } = match?.params || {};

  return { workspaceId, organisationId };
};
